module.exports = __webpack_public_path__ + "static/media/surveyBackground.1c029a33.png";